import { authPlan } from './AuthStore';
import { authPlanDefault } from './AuthStoreDefaults';

export const resetAuthPlan = () => authPlan.set(authPlanDefault);
